import * as React from 'react';
import { Price } from '@grandvisionhq/common';
import { Text } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';
import { isNil } from '@grandvisionhq/utils';

const ShippingMethodInfo = ({ price , logo , isFree  })=>{
    const { currency , getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement(React.Fragment, null, logo, !isFree && !isNil(price) && /*#__PURE__*/ React.createElement(Price, {
        value: price,
        centAmount: true,
        currency: currency,
        className: "checkout-shipping-methods__price"
    }), isFree && /*#__PURE__*/ React.createElement(Text, {
        className: "checkout-shipping-methods__label"
    }, getLabel('common.free')));
};

export { ShippingMethodInfo };
//# sourceMappingURL=ShippingMethodInfo.js.map
